/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2024 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */
const Footer = () => {
    const version = require('../../../package.json').version;
    const date = require('../../../package.json').date;
    return (
        <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
            <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
                <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0 md:text-base">
                  <a href="https://www.crompton.co.in/"  target="blank" className="text-base font-medium text-gray-600 hover:text-gray-600">
                    ©{1900 + new Date().getYear()} Crompton Greaves Consumer Electricals Ltd.
                  </a>

                </p>
            </h5>
            <div>
                <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-10">
                  <li>
                    <a
                        target="blank"
                        href="https://www.crompton.co.in/pages/terms-of-service"
                        className="text-base font-medium text-gray-600 hover:text-gray-600"
                    >
                      Terms of service
                    </a>
                  </li>
                  <li>
                    <a
                        target="blank"
                        href="https://www.crompton.co.in/pages/privacy-notice"
                        className="text-base font-medium text-gray-600 hover:text-gray-600"
                    >
                      Privacy Notice
                    </a>
                  </li>
                    <li>
                        <a
                            target="blank"
                            href="https://www.crompton.co.in/pages/cookie-policy"
                            className="text-base font-medium text-gray-600 hover:text-gray-600"
                        >
                            Cookie Policy
                        </a>
                    </li>
                    <li>
                        <a
                            className="text-base font-medium text-gray-600 hover:text-gray-600"
                        >
                            Version: {version}
                        </a>
                    </li>
                    <li>
                        <a
                            className="text-base font-medium text-gray-600 hover:text-gray-600"
                        >
                            Last Update: {date}
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    );
};

export default Footer;
